import { render, staticRenderFns } from "./ProcurationStep1.vue?vue&type=template&id=363b3580&scoped=true&"
import script from "./ProcurationStep1.vue?vue&type=script&lang=js&"
export * from "./ProcurationStep1.vue?vue&type=script&lang=js&"
import style0 from "./ProcurationStep1.vue?vue&type=style&index=0&id=363b3580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b3580",
  null
  
)

export default component.exports